import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default function getHexConsumerIdForUser(emailAddress: string): string {
    if (!isConsumer() || !emailAddress) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (9,9): Type 'undefined' is not assignable to type 'string'.
        // @ts-expect-error
        return undefined;
    }

    const userConfig = getUserConfiguration();
    if (!userConfig || !userConfig.SessionSettings) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (17,9): Type 'undefined' is not assignable to type 'string'.
        // @ts-expect-error
        return undefined;
    }

    // If the persona is yourself, return the current user hex id.
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (24,46): Argument of type 'RecursiveReadOnly<string | undefined>' is not assignable to parameter of type 'string'.
    // @ts-expect-error
    if (isSameStringIgnoreCase(emailAddress, userConfig.SessionSettings.UserEmailAddress)) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (28,9): Type 'RecursiveReadOnly<string | undefined>' is not assignable to type 'string'.
        // @ts-expect-error
        return userConfig.HexCID;
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (34,5): Type 'undefined' is not assignable to type 'string'.
    // @ts-expect-error
    return undefined;
}

function isSameStringIgnoreCase(str1: string, str2: string): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (41,5): Type 'string | boolean' is not assignable to type 'boolean'.
    // @ts-expect-error
    return str1 && str2 && str1.toLowerCase() == str2.toLowerCase();
}
